/**
 * Hub 正文 inline 内链匹配表（label 越长越优先）
 */
var BASE_INLINE_LINK_TARGETS = [
  { label: 'Miral AI Background Remover', path: '/tools/background-remover' },
  { label: 'Miral AI', path: '/' },
  { label: 'Miral', path: '/' },
  { label: 'Qwen Image 2.0 Pro', path: '/image-models/qwen-image-2-0-pro-ai-image-generator' },
  { label: 'Stable Diffusion 3.5', path: '/image-models/stable-diffusion-ai-image-generator' },
  { label: 'Image Crop & Dewarp', path: '/tools/doc-crop-enhance' },
  { label: 'AI Watermark Remover', path: '/tools/watermark-remover' },
  { label: 'AI Background Remover', path: '/tools/background-remover' },
  { label: 'Handwriting Eraser', path: '/tools/handwritten-erase' },
  { label: 'GPT Image 1.5', path: '/image-models/gpt-image-ai-image-generator' },
  { label: 'Z Image Turbo', path: '/image-models/z-image-turbo-ai-image-generator' },
  { label: 'Stable Diffusion', path: '/image-models/stable-diffusion-ai-image-generator' },
  { label: 'GPT Image', path: '/image-models/gpt-image-ai-image-generator' },
  { label: 'Qwen Image', path: '/image-models/qwen-image-2-0-pro-ai-image-generator' },
  { label: 'Midjourney', path: '/image-models/midjourney-ai-image-generator' },
  { label: 'Flux Schnell', path: '/image-models/flux-1-ai-image-generator' },
  { label: 'Seedream 5', path: '/image-models/seedream-ai-image-generator' },
  { label: 'Seedream', path: '/image-models/seedream-ai-image-generator' },
  { label: 'FLUX.2', path: '/image-models/flux-2-ai-image-generator' },
  { label: 'FLUX', path: '/image-models/flux-2-ai-image-generator' },
  { label: 'Z Image', path: '/image-models/z-image-turbo-ai-image-generator' }
]

var LOCALE_INLINE_LINK_ALIASES = {
  // 中文额外别名；其它语言走 HUB_TEXT.docSearchAliasLinks（localeFactory）
  zh: [
    { label: 'Miral AI 背景移除', path: '/tools/background-remover' },
    { label: 'AI 文档切边矫正', path: '/tools/doc-crop-enhance' },
    { label: '图片裁剪矫正', path: '/tools/doc-crop-enhance' },
    { label: 'AI 手写文字擦除', path: '/tools/handwritten-erase' },
    { label: 'Handwriting Eraser', path: '/tools/handwritten-erase' },
    { label: 'AI Watermark Remover', path: '/tools/watermark-remover' },
    { label: 'AI 背景移除', path: '/tools/background-remover' },
    { label: '图片去背景', path: '/tools/background-remover' },
    { label: '在线抠图', path: '/tools/background-remover' },
    { label: '手写擦除', path: '/tools/handwritten-erase' },
    { label: '文档矫正', path: '/tools/doc-crop-enhance' },
    { label: 'AI 去水印', path: '/tools/watermark-remover' },
    { label: '去水印', path: '/tools/watermark-remover' },
    { label: 'AI 图片增强', path: '/tools/image-enhancer' },
    { label: 'AI 物体移除', path: '/tools/object-remover' }
  ],
  ja: [
    { label: 'Miral AI 背景除去', path: '/tools/background-remover' },
    { label: 'AI 背景除去', path: '/tools/background-remover' },
    { label: '背景除去', path: '/tools/background-remover' },
    { label: 'AI画像強化', path: '/tools/image-enhancer' },
    { label: 'AIオブジェクト除去', path: '/tools/object-remover' },
    { label: 'AI透かし除去', path: '/tools/watermark-remover' },
    { label: '透かし除去', path: '/tools/watermark-remover' },
    { label: '手書き消去', path: '/tools/handwritten-erase' },
    { label: '文書の切り抜き・補正', path: '/tools/doc-crop-enhance' }
  ],
  ko: [
    { label: 'Miral AI 배경 제거', path: '/tools/background-remover' },
    { label: 'AI 배경 제거', path: '/tools/background-remover' },
    { label: '배경 제거', path: '/tools/background-remover' },
    { label: 'AI 이미지 향상', path: '/tools/image-enhancer' },
    { label: 'AI 오브젝트 제거', path: '/tools/object-remover' },
    { label: 'AI 워터마크 제거', path: '/tools/watermark-remover' },
    { label: '손글씨 제거', path: '/tools/handwritten-erase' },
    { label: '문서 자르기 및 보정', path: '/tools/doc-crop-enhance' }
  ],
  fr: [
    { label: 'Suppression d’arrière-plan Miral AI', path: '/tools/background-remover' },
    { label: 'Suppression d’arrière-plan IA', path: '/tools/background-remover' },
    { label: 'Amélioration d’image IA', path: '/tools/image-enhancer' },
    { label: 'Suppression d’objets IA', path: '/tools/object-remover' },
    { label: 'Suppression de filigrane IA', path: '/tools/watermark-remover' }
  ],
  es: [
    { label: 'Eliminador de fondo Miral AI', path: '/tools/background-remover' },
    { label: 'Eliminador de fondo IA', path: '/tools/background-remover' },
    { label: 'Mejorador de imágenes IA', path: '/tools/image-enhancer' },
    { label: 'Eliminador de objetos IA', path: '/tools/object-remover' },
    { label: 'Eliminar marca de agua con IA', path: '/tools/watermark-remover' }
  ],
  it: [
    { label: 'Rimozione sfondo Miral AI', path: '/tools/background-remover' },
    { label: 'Rimozione sfondo IA', path: '/tools/background-remover' },
    { label: 'Miglioramento immagini IA', path: '/tools/image-enhancer' },
    { label: 'Rimozione oggetti IA', path: '/tools/object-remover' },
    { label: 'Rimozione watermark IA', path: '/tools/watermark-remover' }
  ],
  de: [
    { label: 'Miral AI Hintergrundentferner', path: '/tools/background-remover' },
    { label: 'KI-Hintergrundentferner', path: '/tools/background-remover' },
    { label: 'KI-Bildverbesserung', path: '/tools/image-enhancer' },
    { label: 'KI-Objektentferner', path: '/tools/object-remover' },
    { label: 'KI-Wasserzeichen entfernen', path: '/tools/watermark-remover' }
  ],
  pt: [
    { label: 'Removedor de fundo Miral AI', path: '/tools/background-remover' },
    { label: 'Removedor de fundo IA', path: '/tools/background-remover' },
    { label: 'Aprimorador de imagens IA', path: '/tools/image-enhancer' },
    { label: 'Remover objetos com IA', path: '/tools/object-remover' },
    { label: 'Remover marca d’água com IA', path: '/tools/watermark-remover' }
  ],
  pl: [
    { label: 'Usuwanie tła Miral AI', path: '/tools/background-remover' },
    { label: 'Usuwanie tła AI', path: '/tools/background-remover' },
    { label: 'Wyostrzanie obrazów AI', path: '/tools/image-enhancer' },
    { label: 'Usuwanie obiektów AI', path: '/tools/object-remover' },
    { label: 'Usuwanie znaków wodnych AI', path: '/tools/watermark-remover' }
  ],
  ar: [
    { label: 'أداة إزالة الخلفية من Miral AI', path: '/tools/background-remover' },
    { label: 'أداة إزالة الخلفية بالذكاء الاصطناعي', path: '/tools/background-remover' },
    { label: 'تحسين الصور بالذكاء الاصطناعي', path: '/tools/image-enhancer' },
    { label: 'إزالة الكائنات بالذكاء الاصطناعي', path: '/tools/object-remover' },
    { label: 'إزالة العلامة المائية بالذكاء الاصطناعي', path: '/tools/watermark-remover' }
  ]
}

function uniqByLabel(items) {
  var seen = {}
  var out = []
  var i
  for (i = 0; i < (items || []).length; i++) {
    var item = items[i]
    var label = String(item && item.label || '').trim()
    var path = String(item && item.path || '').trim()
    if (!label || !path || seen[label]) continue
    seen[label] = true
    out.push({ label: label, path: path })
  }
  return out
}

function getInlineLinkTargets(locale, extraLinks) {
  var list = BASE_INLINE_LINK_TARGETS.concat(LOCALE_INLINE_LINK_ALIASES[locale] || [])
  list = list.concat(extraLinks || [])
  list = uniqByLabel(list)
  list.sort(function (a, b) {
    return b.label.length - a.label.length
  })
  return list
}

module.exports = {
  BASE_INLINE_LINK_TARGETS: BASE_INLINE_LINK_TARGETS,
  LOCALE_INLINE_LINK_ALIASES: LOCALE_INLINE_LINK_ALIASES,
  getInlineLinkTargets: getInlineLinkTargets
}
